import './Modal.css';
export var backdrop = '_dmotjm4-3-12-1';
export var backdropOpacityVar = '--strato-modal-fade-opacity';
export var base = '_dmotjm0-3-12-1';
export var content = {withFooter:'_dmotjm7-3-12-1',withoutFooter:'_dmotjm8-3-12-1'};
export var dividerWrapper = '_dmotjm6-3-12-1';
export var footerSection = '_dmotjm9-3-12-1';
export var header = '_dmotjm5-3-12-1';
export var sizes = {small:'_dmotjm1-3-12-1',medium:'_dmotjm2-3-12-1',large:'_dmotjm3-3-12-1'};